import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';

type ChangePricesState = {
  isOpen?: boolean;
};

const initialState: ChangePricesState = {
  isOpen: false,
};

const slice = createSlice({
  name: 'ipa.priceManager.modals.changePrices',
  initialState,
  reducers: {
    SET_IS_OPEN(state, action: PayloadAction<boolean>) {
      state.isOpen = action.payload;
    },
  },
});

export const { SET_IS_OPEN } = slice.actions;

export default slice.reducer;

export const selectorChangePricesModal = (state: RootState) => {
  return state.ipa.priceManager.modals.changePrices;
};
